import { defineMessages } from '@jutro/locale';

export default defineMessages({
    retrieveQuote: {
        id: 'quoteandbind.directives.AvailableProductsAndFeatures.Retrieve Quote',
        defaultMessage: 'Retrieve Quote',
    },
    retrieveQuoteDescription: {
        id: 'quoteandbind.directives.AvailableProductsAndFeatures.Retrieve A Quote Help Text',
        defaultMessage: 'Please enter your ZIP code and the quote ID you have received by email to retrieve your quote.',
    },
    enterZipCode: {
        id: 'quoteandbind.directives.ProductZipCodeContainer.Enter ZIP Code',
        defaultMessage: 'Enter ZIP Code',
    },
    enterQuoteID: {
        id: 'quoteandbind.directives.ProductZipCodeContainer.Enter Quote ID',
        defaultMessage: 'Enter Quote ID',
    },
    continue: {
        id: 'quoteandbind.directives.ProductZipCodeContainer.Continue',
        defaultMessage: 'Continue',
    },
    cancel: {
        id: 'quoteandbind.directives.ProductZipCodeContainer.Cancel',
        defaultMessage: 'Cancel',
    },
    mlRetrieveQuote: {
        id: 'ml.quoteandbind.common.RetrieveQuote.Retrieve Quote',
        defaultMessage: 'Let\'s retrieve your quote',
    },
    mlZipCode: {
        id: 'ml.quoteandbind.common.RetrieveQuote.ZIP Code',
        defaultMessage: 'ZIP Code',
    },
    mlEnterZipCode: {
        id: 'ml.quoteandbind.common.RetrieveQuote.Please enter your ZIP code',
        defaultMessage: 'Please enter your ZIP code',
    },
    mlRetrieveQuoteDescription: {
        id: 'ml.quoteandbind.common.RetrieveQuote.Retrieve A Quote Help Text',
        defaultMessage: 'To retrieve your quote, please tell us your quote number or email address',
    },
    mlQuoteID: {
        id: 'ml.quoteandbind.common.RetrieveQuote.Quote Number',
        defaultMessage: 'Quote Number'
    },
    mlEnterQuoteNumber: {
        id: 'ml.quoteandbind.common.RetrieveQuote.Enter Quote Number',
        defaultMessage: 'Please enter your quote number'
    },
    mlEmailAddress: {
        id: 'ml.quoteandbind.common.RetrieveQuote.Email Address',
        defaultMessage: 'Email Address'
    },
    mlEnterEmailAddress: {
        id: 'ml.quoteandbind.common.RetrieveQuote.Enter Email Address',
        defaultMessage: 'Email address'
    },
    mlStartANewQuote: {
        id: 'ml.quoteandbind.common.RetrieveQuote.START A NEW QUOTE',
        defaultMessage: 'START A NEW QUOTE'
    },
    mlContinueMyQuote: {
        id: 'ml.quoteandbind.common.RetrieveQuote.CONTINUE MY QUOTE',
        defaultMessage: 'CONTINUE MY QUOTE'
    },
    mlModalCloseWindowButton: {
        id: 'ml.quoteandbind.common.RetrieveQuote.CLOSE WINDOW',
        defaultMessage: 'CLOSE WINDOW'
    },
    clickContinueMyQuote: {
        id: 'ml.quoteandbind.common.RetrieveQuote.You can click CONTINUE MY QUOTE to retrieve your existing quote or you can START A NEW QUOTE',
        defaultMessage: 'You can click CONTINUE MY QUOTE to retrieve your existing quote or you can START A NEW QUOTE'
    },
    welcomeBack: {
        id: 'ml.quoteandbind.common.RetrieveQuote.Welcome back, !',
        defaultMessage: 'Welcome back, {name}!'
    }
});
